module.exports = __webpack_public_path__ + "static/fsu@2x-fa7b001bdb85ea76baab4ac799b2fa7b.png";